<template>
  <div class="overview-index">
    <a-row :gutter="12">
      <a-col :span="18">
        <div class="bill-card">
          <div class="bill-card-title">{{$t('scope.text_430')}}<a-tag color="orange" class="ml-2" v-if="overviewDetails.is_overdue">{{$t('scope.text_462')}}</a-tag>
            <a-tag color="red" class="ml-2" v-if="overviewDetails.is_arrears">{{$t('scope.text_463')}}</a-tag>
            <a-tag color="green" class="ml-2" v-if="!overviewDetails.is_overdue && !overviewDetails.is_arrears">{{$t('scope.text_464')}}</a-tag>
            <a-button type="primary" size="small" @click="recharge" v-if="scope !== 'system'">{{$t('scope.text_465')}}</a-button>
          </div>
          <a-row :gutter="12">
            <a-col :span="7">
              <a-col class="text-center" :span="5" />
            </a-col>
            <a-col :span="17">
              <a-col class="text-center" :span="1" />
              <a-col class="text-center f-12" :span="7">{{$t('scope.text_429')}}</a-col>
              <a-col class="text-center f-12" :span="1">-</a-col>
              <a-col class="text-center f-12" :span="7">{{$t('scope.text_466')}}</a-col>
              <a-col class="text-center f-12" :span="1">-</a-col>
              <a-col class="text-center f-12" :span="7">{{$t('scope.text_467')}}</a-col>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="7">
              <a-col class="text-center" :span="24">
                <span class="font-weight-bold money" style="line-height: 48px">
                {{ (Number(getValue('balance', overviewDetails)) -  Number(getValue('due', overviewDetails)) - Number(getValue('pending_due', overviewDetails))).toFixed(2)}}
                </span>
                <span class="ml-2 f-12">{{overviewDetails.currency === 'CNY' ? $t('scope.text_468') : $t('scope.text_469')}}</span>
              </a-col>
            </a-col>
            <a-col :span="17">
              <a-col class="text-center" style="line-height: 48px" :span="1">=</a-col>
              <a-col class="text-center font-weight-bold money cursor-pointer" style="line-height: 48px" :span="7" @click="handleMoneyClick('/income-expenditure-details')">{{getValue('balance', overviewDetails)}}</a-col>
              <a-col class="text-center" style="line-height: 48px" :span="1">-</a-col>
              <a-col class="text-center font-weight-bold money cursor-pointer" style="line-height: 48px" :span="7" @click="handleMoneyClick('/bill-accounted')">{{getValue('due', overviewDetails)}}</a-col>
              <a-col class="text-center" style="line-height: 48px" :span="1">-</a-col>
              <a-col class="text-center font-weight-bold money cursor-pointer" style="line-height: 48px" :span="7" @click="handleMoneyClick('/bill-pending-due')">{{getValue('pending_due', overviewDetails)}}</a-col>
            </a-col>
          </a-row>
        </div>
      </a-col>
      <a-col :span="6">
        <money-card
          class="mb-2"
          :title="$t('scope.text_470')"
          :value="totalSave"
          height="142px"
          :showAlert="showAlert"
          :currencyCn="overviewDetails.currency === 'CNY' ? $t('scope.text_468') : $t('scope.text_469')" />
      </a-col>
    </a-row>
    <!-- <a-row :gutter="12">
      <a-col :span="6">
        <a-card :title="$t('scope.text_471')" class="mb-2">
          <router-link slot="extra" to="/integral">{{$t('scope.text_278')}}</router-link>
          <p>{{$t('scope.text_472')}}<span class="font-weight-bold money">{{ overviewDetails.points | numerify('0,0.00') }}</span></p>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card :title="$t('scope.text_277')" class="mb-2">
          <router-link slot="extra" to="/voucher">{{$t('scope.text_293')}}</router-link>
          <p>{{$t('scope.text_473', [ overviewDetails.coupon_count ])}}<span class="font-weight-bold money">{{ overviewDetails.coupon | numerify('0,0.00') }}</span></p>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card :title="$t('scope.text_474')" class="mb-2">
          <router-link slot="extra" to="/invoice-application">{{$t('scope.text_475')}}</router-link>
          <p>{{$t('scope.text_476')}}<span class="font-weight-bold money">{{ overviewDetails.invoiceable | numerify('0,0.00') }}</span>{{$t('scope.text_468')}}</p>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card :title="$t('scope.text_436')" class="mb-2">
          <router-link slot="extra" to="/bill-pending-payment">{{$t('scope.text_266')}}</router-link>
          <p>{{$t('scope.text_477', [ overviewDetails.on_pay_count || 0 ])}}<span class="font-weight-bold money">{{ overviewDetails.on_pay | numerify('0,0.00') }}</span></p>
        </a-card>
      </a-col>
    </a-row> -->
    <a-divider />
    <div class="mb-4" style="overflow: auto;">
      <a-radio-group class="float-right" v-model="productType" @change="orderTypeChange">
        <a-radio-button v-for="item in productTypes" :value="item.id" :key="item.id">
          {{item.label}}
        </a-radio-button>
      </a-radio-group>
    </div>
    <consumption-trend
      class="mt-2"
      :header="monthHeader"
      :columns="orderColumns"
      :rows="orderRows"
      :labelMap="orderLabelMap"
      :setting-options="orderSettingOptions">
      <template #header-right>
        <a-radio-group class="float-right mt-1" size="small" v-model="activeOrderBtn">
          <a-radio-button v-for="item in OrderBtns" :value="item.value" :key="item.value">
            {{item.text}}
          </a-radio-button>
        </a-radio-group>
        <a-radio-group class="float-right mr-4 mt-1" size="small" v-model="orderCurrency" @change="orderCurrencyChange">
          <a-radio-button v-for="item in orderHasCurrencyTypes" :value="item" :key="item">
            {{item}}
          </a-radio-button>
        </a-radio-group>
      </template>
    </consumption-trend>
    <consumption-trend
      class="mt-2"
      :header="yearHeader"
      :columns="billColumns"
      :rows="billRows"
      :labelMap="billLabelMap"
      :setting-options="billSettingOptions" />
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import ConsumptionTrend from './consumptionTrend'
import { completionDate } from '@/utils/utils'
import MoneyCard from '@Bill/sections/MoneyCard'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'TennatOverviewIndex',
  components: {
    MoneyCard,
    ConsumptionTrend,
  },
  mixins: [WindowsMixin],
  props: {
    resId: String,
    billId: String,
  },
  data () {
    return {
      orderHistoryData: [],
      billHistoryData: [],
      formatOrderHistoryData: [],
      formatBillHistoryData: [],
      currencyOrderHistoryData: [],
      showAlert: false,
      monthHeader: {
        title: this.$t('scope.text_478'),
      },
      yearHeader: {
        title: this.$t('scope.text_479'),
      },
      loading: false,
      overviewDetails: {},
      OrderBtns: [
        {
          value: 'month',
          text: this.$t('scope.text_480'),
        },
        {
          value: 'lastMonth',
          text: this.$t('scope.text_481'),
        },
      ],
      activeOrderBtn: 'month',
      billAccountId: '',
      orderCurrency: 'USD',
      productTypes: [{
        label: this.$t('scope.text_482'),
        id: 'subscription',
      }, {
        label: this.$t('scope.text_425'),
        id: 'commodity',
      }],
      orderColumns: ['time', 'origin_cost', 'subtotal'],
      billColumns: ['time', 'coupon_amount', 'onpay_amount', 'paid_amount'],
      orderRows: [],
      billRows: [],
      orderLabelMap: {
        origin_cost: this.$t('scope.text_483'),
        subtotal: this.$t('scope.text_484'),
      },
      billLabelMap: {
        coupon_amount: this.$t('scope.text_277'),
        onpay_amount: this.$t('scope.text_436'),
        paid_amount: this.$t('scope.text_437'),
      },
      productType: 'subscription',
      orderSettingOptions: {
        origin_cost: {
          barWidth: 20,
          itemStyle: {
            color: '#ddd',
            borderColor: '#F1F1F1',
            borderType: 'dashed',
            opacity: 0.6,
          },
        },
        subtotal: {
          barWidth: 20,
          barGap: '-100%',
          z: 10,
          itemStyle: {
            color: '#4DA1FF',
            opacity: 0.6,
          },
        },
      },
      billSettingOptions: {
        coupon_amount: {
          barWidth: 20,
          itemStyle: {
            color: '#4DA1FF',
            opacity: 0.6,
          },
          stack: 'a',
        },
        onpay_amount: {
          barWidth: 20,
          itemStyle: {
            color: '#FFC760',
            opacity: 0.6,
          },
          stack: 'a',
        },
        paid_amount: {
          barWidth: 20,
          itemStyle: {
            color: '#F76F89',
            opacity: 0.6,
          },
          stack: 'a',
        },
      },
      orderHasCurrencyTypes: ['CNY', 'USD'],
    }
  },
  computed: {
    ...mapGetters(['scope', 'userInfo', 'isAdminMode']),
    ...mapState('app', {
      customer: state => state.customer,
    }),
    selectedMonth () {
      if (this.activeOrderBtn === 'lastMonth') {
        return this.$moment().subtract(1, 'M').format('YYYYMM')
      }
      return this.$moment().format('YYYYMM')
    },
    totalSave () {
      if (!this.getValue('total_origin', this.overviewDetails)) {
        return 0
      }
      return Number(this.getValue('total_origin', this.overviewDetails)) - Number(this.getValue('total_paid', this.overviewDetails))
    },
    totalOnPay () {
      return this.$t('scope.text_485', [this.getValue('on_pay', this.overviewDetails)])
    },
    totalCoupon () {
      return this.$t('scope.text_485', [this.getValue('coupon', this.overviewDetails)])
    },
  },
  watch: {
    activeOrderBtn () {
      this.fetchOrderHistoryData()
    },
  },
  created () {
    this.accountM = new this.$Manager('billing_accounts')
    this.analysisM = new this.$Manager('bill_analysises', 'v1')
    this.fetchData()
  },
  methods: {
    orderCurrencyChange (e) {
      this.orderCurrency = e.target.value
      const data = this.filterTypeData(this.productType, 'order')
      this.filterCurrencyData(e.target.value, data)
    },
    billCurrencyChange (e) {
      this.billCurrency = e.target.value
      this.filterCurrencyData(e.target.value)
    },
    orderTypeChange (e) {
      this.productType = e.target.value
      const orderData = this.filterTypeData(e.target.value, 'order')
      const BillData = this.filterTypeData(e.target.value, 'bill')
      this.filterCurrencyData(this.orderCurrency, orderData)
      this.composeBillData(BillData)
    },
    recharge () {
      this.createDialog('RechargeAmountDialog', {
        success: () => {
          this.fetchData()
        },
      })
    },
    getValue (key, target, isFormat = true) {
      if (R.hasIn(key, target)) {
        if (isFormat) return target[key].toFixed(2)
        return target[key]
      }
      return 0
    },
    async fetchData () {
      if (!this.billId) {
        const { data: { data = [] } } = await this.accountM.list()
        const { data: res } = await this.accountM.getSpecific({
          id: data[0].id,
          spec: 'balance',
        })
        this.overviewDetails = res
        this.billAccountId = data[0].id
      } else {
        const { data: res } = await this.accountM.getSpecific({
          id: this.billId,
          spec: 'balance',
        })
        this.overviewDetails = res
      }
      this.fetchOrderHistoryData()
      this.fetchBillHistoryData()
    },
    async fetchOrderHistoryData () {
      const { data: historyData } = await this.accountM.getSpecific({
        id: this.billAccountId || this.billId,
        spec: 'order-history',
        params: {
          month: this.selectedMonth,
          timezone: '',
        },
      })
      this.orderHistoryData = historyData.history || []
      if (this.orderHistoryData.length === 0) {
        this.orderRows = []
        this.formatOrderHistoryData = []
      } else {
        this.genData(historyData.history, 'order-history')
      }
    },
    async fetchBillHistoryData () {
      const { data: historyData } = await this.accountM.getSpecific({
        id: this.billAccountId || this.billId,
        spec: 'bill-history',
        params: {
          since: this.$moment().subtract(12, 'M').format('YYYYMM'),
          until: this.$moment().format('YYYYMM'),
          timezone: '',
        },
      })
      this.billHistoryData = historyData.history
      this.genData(historyData.history, 'bill-history')
    },
    genData (originData, resource) {
      // 处理原始数据类型为: [{ time: 'xxx', currency: 'xx', type: 'xx', "subtotal": 'XX', "origin_cost": 'xx' }]
      const list = []
      if (originData) {
        R.forEach((item) => {
          const time = item.date_str
          R.forEachObjIndexed((value, key) => {
            if (resource === 'order-history') {
              const currency = key
              R.forEachObjIndexed((value, key) => {
                const type = key
                const obj = {
                  time,
                  currency,
                  type,
                  subtotal: value.subtotal,
                  origin_cost: value.origin_cost,
                }
                list.push(obj)
              }, value)
            }
            if (resource === 'bill-history') {
              const type = key
              const obj = {
                time,
                type,
                coupon_amount: value.coupon_amount,
                onpay_amount: value.onpay_amount,
                paid_amount: value.paid_amount,
              }
              list.push(obj)
            }
          }, item.record)
        }, originData)
      }
      if (resource === 'order-history') {
        this.formatOrderHistoryData = list
        if (this.formatOrderHistoryData.length > 0) {
          const data = this.filterTypeData('subscription', 'order')
          this.filterCurrencyData(this.orderCurrency, data)
        }
      }
      if (resource === 'bill-history') {
        this.formatBillHistoryData = list
        if (this.formatBillHistoryData.length > 0) {
          const data = this.filterTypeData('subscription', 'bill')
          this.composeBillData(data)
        }
      }
    },
    // 类型分为按需：subscription，commodity：预付费
    filterTypeData (type = 'subscription', resource) {
      const ret = []
      if (resource === 'order') {
        this.formatOrderHistoryData.forEach(item => {
          if (type === item.type) {
            const obj = {
              time: item.time,
              currency: item.currency,
              subtotal: item.subtotal,
              origin_cost: item.origin_cost,
            }
            ret.push(obj)
          }
        })
      } else {
        this.formatBillHistoryData.forEach(item => {
          if (type === item.type) {
            const obj = {
              time: item.time,
              coupon_amount: item.coupon_amount,
              onpay_amount: item.onpay_amount,
              paid_amount: item.paid_amount,
            }
            ret.push(obj)
          }
        })
      }
      return ret
    },
    filterCurrencyData (currencyType, data) {
      if (data.length === 0) {
        this.orderRows = []
        return
      }
      // 过滤currency类型，默认使用数据中第一项
      const arr = R.clone(data.filter(item => item.currency === currencyType))
      // 根据时间进行去重合并，将处理结构处理为组件所需[{ time: 'xx', "subtotal": 'xx', "origin_cost": 'xx' }]
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].time === arr[j].time) {
            arr[i].subtotal = arr[j].subtotal
            arr[i].origin_cost = arr[j].origin_cost
            arr.splice(j, 1)
            j--
          }
        }
      }
      this.currencyOrderHistoryData = arr
      const formatArr = R.clone(arr)
      formatArr.map(item => {
        delete item.currency
        delete item.type
      })
      this.orderRows = completionDate(formatArr, this.selectedMonth, ['subtotal', 'origin_cost'])
    },
    composeBillData (data) {
      const arr = data
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].time === arr[j].time) {
            arr[i].coupon_amount = arr[j].coupon_amount
            arr[i].onpay_amount = arr[j].onpay_amount
            arr[i].paid_amount = arr[j].paid_amount
            arr.splice(j, 1)
            j--
          }
        }
      }
      const result = []
      for (let i = 0; i < 12; i++) {
        let obj = {}
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            const preData = this.$moment().subtract(11, 'M').add(i, 'M').format('YYYY-MM')
            const preDataYear = preData.substring(0, 4)
            const preDataMonth = preData.substring(preData.length - 2)
            const dataItemMonth = arr[j].time.substring(arr[j].time.length - 2)
            const dataItemYear = arr[j].time.substring(0, 4)
            if (dataItemYear === preDataYear && preDataMonth === dataItemMonth) {
              obj = arr[j]
              obj = {
                ...obj,
                time: preData,
              }
              break
            } else {
              obj = {
                time: preData,
              }
            }
          }
        } else {
          const time = this.$moment().subtract(11, 'M').add(i, 'M').format('YYYY-MM')
          obj.time = time
        }
        const keys = ['coupon_amount', 'onpay_amount', 'paid_amount']
        keys.map(item => {
          if (!obj[item]) {
            obj[item] = 0
          }
        })
        result.push(obj)
      }
      this.billRows = result
    },
    handleMoneyClick (path) {
      this.$router.push(path)
    },
  },
}
</script>

<style lang="less" scoped>
.f-12 {
  font-size: 12px;
}
.money {
  font-size: 32px;
  color: rgb(77, 161, 255);
}
.cursor-pointer {
  cursor: pointer;
}
.bill-card {
  width: 100%;
  height: 142px;
  border: 1px solid #F1F1F1;
  padding: 12px 24px;
  .bill-card-title {
    font-size: 12px;
  }
}
</style>
